import { Modal, Backdrop, Fade } from "@mui/material";
import React from "react";
import { AiOutlineExclamationCircle } from "react-icons/ai";
const ModalContent = ({
  children,
  open = false,
  onClose,
  variant,
  className,
  ...rest
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 200,
        },
      }}
    >
      <Fade in={open}>
        <div
          className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${className}
              bg-white wce-soft focus-visible:outline-none min-w-[320px] xs:min-w-[416px]`}
          {...rest}
        >
          {variant === "danger" ? (
            <>
              <AiOutlineExclamationCircle
                size={22}
                className="text-wce-pink-bright min-w-[22px]"
              />
              {children}
            </>
          ) : (
            children
          )}
        </div>
      </Fade>
    </Modal>
  );
};

export default ModalContent;
